import { createContext, useContext } from "react";
import useWebSocket from "../hooks/useWebSocket";

const WebSocketContext = createContext({
  isConnected: false,
  error: null,
  connect: () => {},
  disconnect: () => {},
  markNotificationsRead: () => {},
  ping: () => {},
  requestNotificationPermission: () => {},
});

export const useWebSocketContext = () => useContext(WebSocketContext);

const WebSocketProvider = ({ children }) => {
  const webSocketValue = useWebSocket();

  return (
    <WebSocketContext.Provider value={webSocketValue}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketProvider;
